import { Injectable } from '@angular/core';
import { DataFieldModel } from '../data-field.model';
import {
    DataFieldGroupEditItemDialogComponent,
    IDialogEditItemResult,
} from './dialog-edit-item/dialog-edit-item.component';
import { fiTryContentLanguage, fiTryContentLanguageValue } from '@fi-shared/utils/try-content-language-value';
import { ContentLanguageLabelModel } from '@fi-shared/models';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';

@Injectable()
export class DataFieldGroupEditItemService {
    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private customerDataService: FiCustomerDataService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    handleEditItem(item: DataFieldModel, selectedLanguageItem): Promise<void> {
        return new Promise((resolve) => {
            this.fiDialogsService
                .custom({
                    headerText: this.appTextService.get(
                        item.Id ? 'data_field_edit_dialog.title' : 'data_field_edit_dialog.title_new',
                    ),
                    contentComponentRef: DataFieldGroupEditItemDialogComponent,
                    contentComponentData: {
                        item: item,
                        languageId: selectedLanguageItem.Id,
                        selectedLanguage: selectedLanguageItem,
                    },
                    config: {
                        panelClass: 'data-field-group-edit-dialog-panel',
                        closeOnNavigation: false,
                    },
                })
                .onYesButtonClick((result) => {
                    processEditItemResult(
                        item,
                        result,
                        selectedLanguageItem.Id,
                        selectedLanguageItem.SortIndex,
                        this.customerDataService.customerData.DefaultApplicationLanguageType,
                    );
                    resolve();
                })
                .afterClosed(() => (this.saveChangesWarningService.closeDialogOnTransition = false));
            this.saveChangesWarningService.closeDialogOnTransition = true;
        });
    }
}

function processEditItemResult(
    item: DataFieldModel,
    result: IDialogEditItemResult,
    languageId: number,
    sortIndex: number,
    defaultApplicationLanguageType: number,
) {
    const nameLabel = fiTryContentLanguage(item.Names, languageId);
    if (nameLabel) {
        nameLabel.Value = result.Name;
    } else {
        item.Names.push(new ContentLanguageLabelModel(languageId, result.Name, sortIndex));
    }
    item.IsEnabled = result.IsEnabled;
    item.IsSetRequired = result.IsSetRequired;
    item.Type = result.Type;
    item.VisibleFor = result.VisibleFor;
    item.PreSetOptions = result.PreSetOptions;
    item.IsMultipleChoice = result.IsMultipleChoice;

    // add default language label for pre-set options
    item.PreSetOptions.forEach((option) => {
        const defaultName = fiTryContentLanguage(option.Names, defaultApplicationLanguageType);
        if (!defaultName)
            option.Names.push(
                new ContentLanguageLabelModel(
                    defaultApplicationLanguageType,
                    fiTryContentLanguageValue(option.Names, languageId),
                    sortIndex,
                ),
            );
    });
}
